import EstablishmentProfile from 'modules/dashboard/profile/EstablishmentProfile'
import ProducerProfile from 'modules/dashboard/profile/ProducerProfile'
import React, { useState } from 'react'
import DashContainer from 'modules/dashboard/_common/DashContainer'
import RightSlotProfile from 'modules/dashboard/profile/right-slot/RightSlotProfile'
import RightSlotProducerProfile from 'modules/dashboard/profile/right-slot/RightSlotProducerProfile'
import EstablishmentProvider from 'context/establishments/Establishment'
import BackButtonCollapseDashProvider from 'context/dash/BackButtonCollapseDash'
import ShowAllEventsProvider from 'context/dash/ShowAllEvents'
import EstablishmentTagsProvider from 'context/establishments/EstablishmentTags'
import BackButtonCollapseProvider from 'context/general/BackButtonCollapse'
import DetailVisibleProvider from 'context/dash/DetailVisible'
import { useUser } from 'context/user/User'
import roles from 'helpers/roles'

export default function DashProfile() {

  const { user } = useUser()
  const [editProfileClick, setEditProfileClick] = useState(0)
  const [hasProducerProfile, setHasProducerProfile] = useState(false)

  const isProducer = user?.role?.id == roles.PRODUCER
  const isEstablishment = user?.role?.id == roles.ESTABLISHMENT || user?.role?.id == roles.ADMIN

  function rightSlotContent() {
    if (isProducer) {
      return (
        <RightSlotProducerProfile
          hasProfile={hasProducerProfile}
          onEditProfile={() => setEditProfileClick(editProfileClick + 1)}
        />
      )
    }

    return (
      <RightSlotProfile onEditProfile={() => setEditProfileClick(editProfileClick + 1)} />
    )
  }

  if (isProducer) {
    return (
      <DashContainer title={'Produtor'} rightSlot={() => rightSlotContent()}>
        <ProducerProfile editProfileClick={editProfileClick} onProfileLoaded={setHasProducerProfile} />
      </DashContainer>
    )
  }

  return (
    <BackButtonCollapseDashProvider>
      <DetailVisibleProvider>
        <EstablishmentTagsProvider>
          <ShowAllEventsProvider>
            <EstablishmentProvider>
              <BackButtonCollapseProvider>

                <DashContainer title={'Estabelecimento'} rightSlot={() => rightSlotContent()}>
                  <EstablishmentProfile editProfileClick={editProfileClick} />
                </DashContainer>

              </BackButtonCollapseProvider>
            </EstablishmentProvider>
          </ShowAllEventsProvider>
        </EstablishmentTagsProvider>
      </DetailVisibleProvider>
    </BackButtonCollapseDashProvider>
  )
}
